export default "__VITE_ASSET__B7NkI3YJ__"